"use client";

import { motion } from "framer-motion";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Mail, Phone } from "lucide-react";
import { itemVariants } from "@/lib/animation-variants";

export default function HelpContactCard() {
  return (
    <motion.div variants={itemVariants}>
      <Card variant="default" title="Hilfe & Kontakt">
        <CardHeader />
        <CardContent>
          <p className="mb-4 text-body-sm text-gray-700">
            Du brauchst Hilfe bei der Anmeldung oder hast Rückfragen? Wir unterstützen Dich gern.
          </p>
          <div className="space-y-3">
            <a
              href="mailto:organisation@gothia150.de"
              className="flex items-center gap-3 text-body-sm text-gothia-green transition-colors hover:text-gothia-gold">
              <Mail className="h-4 w-4 shrink-0" />
              <span>organisation@gothia150.de</span>
            </a>
            <a
              href="tel:015679712923"
              className="flex items-center gap-3 text-body-sm text-gothia-green transition-colors hover:text-gothia-gold">
              <Phone className="h-4 w-4 shrink-0" />
              <span>015679 712923</span>
              <span className="text-xs text-gray-600">(Jubelsenior)</span>
            </a>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
